<template>
  <div>
    <mall-header></mall-header>
    <div class="guide-content" ></div>
     <div class="invoiceList-header" >
    <nav-Menu></nav-Menu>
    <div class=" invoiceList-div" >
        <span class="invoiceList-span">发票管理</span>
        <span class="invoiceList-span-line" ></span>
        <el-button icon="el-icon-plus"   @click="invoiceOpen" class="inoviceButton"  >发票申请</el-button>
        <div  class="mainClass" style="    float: left;  " >
            <el-table :data="invoiceList"  @filter-change="filterChange" v-loading="fullscreenLoading"   :default-sort = "{prop: 'createTime', order: 'descending'}"   :row-style="{height:'45px'}"  :cell-style="{'padding':'8px'}" class="invoiceList-table"   :header-cell-style="{background: '#F6F6F6',color:'#666666','font-size': '14px','font-family': 'PingFang SC','font-weight': '500'}">
                <el-table-column prop="createTime" align="left"  label="申请时间" width="200"></el-table-column>
                <el-table-column  style="height: 40px;" label="抬头类型" align="left" width="140" prop="billingTypeName">
                </el-table-column>
                <el-table-column  style="height: 40px;" width="180" label="发票抬头" align="left">
                    <template slot-scope="scope">
                     <el-tooltip placement="right"  :open-delay="500"  :disabled="inoviceTips" :content='scope.row.billingTitle' >
                        <span  class="invoice-column-font" @mouseenter="inoviceTipsFun($event)"  @click="serverClick(scope.row)">{{scope.row.billingTitle}}</span>
                     </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column  prop="orderNum" style="height: 40px;" label="订单数量" align="center" width="130"> </el-table-column>
                <el-table-column prop="billingAmount" style="height: 40px;" label="开票金额" align="center" width="150"></el-table-column>
               <el-table-column
               column-key="billingStatusName"
                prop="billingStatusName"
                align="left"
                label="开票状态"
                width="120"
                :filters="[{ text: '待开票', value: '待开票' }, { text: '已开票', value: '已开票'},{ text: '已取消', value: '已取消' }]"
                :filter-multiple="true"
                filter-placement="bottom-end">
                <template slot-scope="scope">
                  <span
                    :style="scope.row.billingStatusName === '已开票' ? 'color:#2CB308' : 'color:#333333'"
                   >{{scope.row.billingStatusName}}</span>
                </template>
              </el-table-column>
              <template slot="empty" >
                  <div  style="  margin-bottom: 100px;   margin-top: 100px;">
                    <img src="../../static/images/空.png" alt="" >
                    <p  class="invoiceList-defut-font">哎呀，什么都没有 T_T</p>
                  </div>
              </template>
            </el-table>
            <div v-if="invoiceList.length>0" id="orderAllPage">
                      <el-pagination background
                        style="margin-top: 0px; float: right;margin-right: 30px;    margin-bottom: 20px;"
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="querydata.pageNo"
                          :page-sizes="[10, 20, 40, 50]"
                          :page-size="querydata.pageSize"
                          layout="total, sizes, prev, pager, next"
                          :total="invoiceTotal">
                      </el-pagination>
                </div>
        </div>
        <el-dialog title="发票申请" class="fpClass"   :visible.sync="dialogTableVisible" width="860px" height="600px;">
          <div  :class="priceShow?'dialogDiv dialog-css':'dialogDiv divInit'">
            <span  class="invoiceList-line " ></span>
            <el-steps :space=400  align-center finish-status="success"  :active="active" >
              <el-step title="选择订单"></el-step>
              <el-step title="发票详情"></el-step>
              <el-step title="完成"></el-step>
            </el-steps>
            <div class="step-line" v-if="active == 0"></div>
            <div class="step-line1" v-if="active == 1"></div>
         <!-- 第一步-->
        <el-table v-show="isListShow"  @row-click="handClick"  :row-style="{height:'45px'}" :cell-style="{padding:'5px'}" :header-cell-style="{height: '40px',background:'#F6F6F6',}"
            ref="multipleTable"
            :data="invoiceOrderList"
            style="width: 820px ;margin-top: 38px;"
            @selection-change="handleSelectionChange" id="a1111">
            <el-table-column
              type="selection"
              width="60">
            </el-table-column>
             <el-table-column
              label="序号"
              type="index"
              align="center"
              width="80">
            </el-table-column>
            <el-table-column
              label="订单编号"
              width="230">
                <template slot-scope="scope">
                      <el-button @click="orderClick(scope.row)" class="invoice-column-button"  type="text" size="small">{{scope.row.orderNo}}</el-button>
                </template>
            </el-table-column>
            <el-table-column
              prop="type_dictText"
              label="订单类型"
              width="140">
            </el-table-column>
            <el-table-column
              prop="totalAmount"
              label="订单总金额"
               align="center"
              width="130"
              >
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="下单时间"
              width="200">
            </el-table-column>

          </el-table>
           <div v-if="isListShow && invoiceOrderList.length>0" style="float:right;margin-top:-15px;" id="orderAllPage">
                <el-pagination background
                  style="margin-top: 20px; float: right;margin-right: 20px;    margin-bottom: 20px;"
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="querydata1.pageNo"
                    :page-sizes="[5, 10, 20, 40]"
                    :page-size="querydata1.pageSize"
                    layout="total, sizes, prev, pager, next"
                    :total="orderTotal">
                </el-pagination>
          </div>
        <!-- 第二步-->
        <div v-if="priceShow" class="nexShow-css" >
          <span  class="headerType-css" >抬头类型：</span>
          <el-radio-group v-model="radio" @change="changeHandler">
            <el-radio  label="1"  class="qyunit-css">企业单位</el-radio>
            <el-radio  label="2"  class="unqyunit-css" >个人/非企业单位</el-radio>
          </el-radio-group>
        </div>
        <div v-if="nexShow" class="nexShow-css-two" >
          <span  class="gsName-css" >公司名称：</span>
          <el-input class="gsName-value-css"
            v-model="companyName">
          </el-input>
        </div>
        <div v-if="nexShow" class="fp-css" >
          <span class="invoice-num-css"><span style="color:#F54743">* </span>发票税号：</span>
          <el-input  class="gsName-value-css" v-model="applyNo" @change="invoiceNoChange">
          </el-input>
          <span class="error error-show" v-show="tipError" style="display: block;position: absolute;color: #F54743;margin-left: 90px;margin-top: 10px;" >发票税号不能为空</span>
          <span class="error error-show" v-show="isRegx" style="display: block;position: absolute;color: #F54743;margin-left: 90px;margin-top: 10px;" >发票税号为12-20位数字或字母</span>
        </div>
        <div v-if="isPrivate" style="    margin-left: 200px;margin-top: 30px;" >
          <span class="invoice-num-css">发票抬头：</span>
          <el-input  class="gsName-value-css" v-model="companyName" >
          </el-input>
        </div>
        <div v-if="priceShow" class="totalje-css" >
          <span class="totalje-span-css" >总金额：</span>
          <span class="totalje-num-css" >￥{{totalPrice}}</span>
        </div>
        <!-- 第三步 -->
          <div v-if="sucShow" style="margin-left: -45px;">
              <img class="suc-img" src="../../static/images/大成功.png"/>
            <span class="suc-bold-font">发票申请成功</span>
            <span class="suc-font-css">您可以在发票管理查看内容</span>
          </div>
          <div :style="isListShow?'position: absolute;margin-top: 60px;margin-left:-4px;':nexShow?' margin-top: 80px;margin-left: 545px;': isPrivate?'margin-top: 142px;margin-left: 545px;':'margin-top: 108px;margin-left: 738px;float: left;margin-bottom: 15px;'">
              <span slot="footer" class="dialog-footer"  >
                <el-button class="prev-button"  v-if="isPevButton" @click="prev">上一步</el-button>
                <el-button class="next-button"  v-if="isNexButton" type="primary" @click="next">下一步</el-button>
                  <el-button  class="close-css" :style="isShowButton?'margin-top: 330px;':''" v-if="isShowButton" @click="closeFn">关闭</el-button>
                <el-button type="primary" class="sure-button"  @click="submit" v-if="isYButton">确 定</el-button>
                <el-button @click="closeFn" class="canle-button"   style=""  v-if="isButton">取 消</el-button>
              </span>
          </div>
        </div>
        </el-dialog>
        <el-backtop  :bottom="100" style="right: auto;" >
        <div
          style="
            height: 100%;
            width: 100%;
            box-shadow: 0 0 6px rgba(0,0,0, .12);
            text-align: center;
            line-height: 40px;
            color: #1989fa; ">
          <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
        </div>
      </el-backtop>
      </div>
    </div>
      <div style="clear: both;height: 90px;">
      </div>
     <mall-footer ></mall-footer>

  </div>
</template>
<script>
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import navMenu from '../components/navMenu.vue'
import axios from 'axios'
import http from '../api/public'
  export default {
    data () {
      return {
        invoiceOrderList:[],
        //currentPage: 4,
        saveSelectData :[],
        dialogTableVisible: false,
        fullscreenLoading:true,
         invoiceList: [
        ],
        isShowButton:false,
        isButton:true,
        isNexButton:true,
        isYButton:false,
        isListShow:true,
        isPevButton :false,
        nexShow:false,
        sucShow:false,
        selectType:0,
        tipError:false,
        isRegx:false,
        isPrivate:false,
        inoviceTips:true,
        nameTips:true,
        priceShow:false,
        active:0,
        activeName: 'first',
        totalPrice:0,
         clientWidth:document.body.clientWidth,
         list: [],
        ids:[],
        radio:"1",
        companyName:"",
        applyNo:"",
        orId:'',
        minute:"29",
        second:"59",
        invoiceTotal:0,
        orderTotal:0,
        querydata:{
          pageNo:1,//初始显示第几页
          pageSize:10//每页显示多少数据
        },
        querydata1:{
          pageNo:1,//初始显示第几页
          pageSize:5//每页显示多少数据
        },
        channel:"",

      }
    },
    mounted() {
      //发票列表数据获取
      this.getInvoiceData();
    },
    methods: {
      //发票列表数据获取
      getInvoiceData() {
        axios.get('/mallApi/mall/invoiceRecord/list',{params:this.querydata ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
          res = res.data;
          if(res.success){
           this.invoiceList = res.result.records;
           this.invoiceTotal = res.result.total;
            for(var i=0;i<this.invoiceList.length;i++){
                this.invoiceList[i].billingAmount = http.changeUnitPrice( this.invoiceList[i].billingAmount);
                  this.invoiceList[i].billingTypeName = this.titelName(this.invoiceList[i].billingType);
                  this.invoiceList[i].billingStatusName = this.billingStatusName(this.invoiceList[i].billingStatus);
                  this.invoiceList[i].createTime = res.result.records[i].createTime.slice(0,res.result.records[i].createTime.lastIndexOf(":"))
            }
          }else{
             if(res.code == 401 || res.code == 400) {
                http.setLocalStorge();
                this.$router.push({path: '/login'});
              }else{
                this.$message({
                  showClose: true,
                  message: '操作失败！',
                  type: 'error'
                });
              }
          }
          if(this.invoiceList.length>1){
            document.getElementsByClassName('el-table__body-wrapper');
          }
          this.fullscreenLoading=false;
        });
      },
      //发票申请列表
      getInvoiceOrderList(){
          axios.get('/mallApi/mall/invoiceRecord/orderList',{params:this.querydata1 ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
            res = res.data;
            if(res.success){
              this.invoiceOrderList = res.result.records;
              this.orderTotal =res.result.total;
              this.invoiceOrderList.forEach(da => {
                  da.totalAmount = http.changeUnitPrice( da.totalAmount);
                });
            }else{
              if(res.code == 401|| res.code == 400) {
                 http.setLocalStorge();
                this.$router.push({path: '/login'});
              }else{
                this.$message({
                  showClose: true,
                  message: '操作失败！',
                  type: 'error'
                });
              }
            }
          });
      },
       handClick(row, event, column) {
         let index = this.list.findIndex(item => {
					// 判断已选数组中是否已存在该条数据
					return item.id == row.id
				})
				if (index == -1) {
					// 如果未存在，设置已选状态，并在list中添加这条数据
					this.$refs.multipleTable.toggleRowSelection(row, true); //设置复选框为选中状态
					this.list.push(row)
				} else {
					// 如果已存在，设置未选状态，并在list中删除这条数据
					this.$refs.multipleTable.toggleRowSelection(row, false); //设置复选框为未选状态
					this.list.splice(index, 1)
				}
       },
      //分页当前页change 事件
      handleCurrentChange(currentPage){
        this.querydata.pageNo = currentPage;
        this.getInvoiceData();
      },
      //分页当前条数 change 事件
      handleSizeChange(pagesize){
        console.log(pagesize)
        this.querydata.pageSize = pagesize;
        this.getInvoiceData();

      },
      //分页当前页change 事件
      handleCurrentChange1(currentPage){
        this.querydata1.pageNo = currentPage;
        this.getInvoiceOrderList();
      },
      //分页当前条数 change 事件
      handleSizeChange1(pagesize){
        console.log(pagesize)
        this.querydata1.pageSize = pagesize;
        this.getInvoiceOrderList();

      },
      //打开申请开票窗口
      invoiceOpen(){
        this.active = 0;
        this.dialogTableVisible = true
        this.isShowButton=false
        this.isButton=true
        this.isNexButton=true
        this.isYButton=false
        this.isListShow=true
        this.isPevButton =false
        this.nexShow=false
        this.priceShow = false
        this.isPrivate = false
        this.sucShow=false
        this.getInvoiceOrderList();
      },
      filterChange(filters) {
        //debugger
        var tempArray = filters.billingStatusName;
        var statusArray =[];
        tempArray.forEach(da => {
          if(da =="待开票"){
            statusArray.push(1)
          }else if(da =="已开票"){
             statusArray.push(2)
          }else if(da =="已取消"){
             statusArray.push(3)
          }
        });
        //debugger
         this.querydata.billingStatus =statusArray.join();
         this.getInvoiceData();
      },
      //勾选订单开票
      handleSelectionChange(val){
          this.saveSelectData = val;
          //console.log(val);
          this.multipleSelection = val;
      },
      //返回发票列表
      openInvoiceList(){
          this.$router.push({ path:'/invoiceList'  })
      },
      //抬头类型转换
     titelName(billingType){
        switch(billingType) {
          case "1":
             return "企业单位"
          case "2":
              return "个人/非企业单位"
          default:
             return ""
        }
      },
      //开票状态转换
      billingStatusName(billingStatus){
        switch(billingStatus) {
          case "1":
             return "待开票"
          case "2":
              return "已开票"
           case "3":
              return "已取消"
          default:
              return ""
        }
      },
      changeHandler(value){
          //debugger
          if(value == "1"){
            this.isPrivate = false;
            this.nexShow = true;
          }else{
            this.isPrivate = true;
            this.nexShow = false;
          }
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
       //打开申请开票窗口
      invoiceOpen(){
        this.active = 0;
        this.dialogTableVisible = true
        this.isShowButton=false
        this.isButton=true
        this.isNexButton=true
        this.isYButton=false
        this.isListShow=true
        this.isPevButton =false
        this.nexShow=false
        this.priceShow = false
        this.isPrivate = false
        this.sucShow=false
        this.getInvoiceOrderList();
      },
     //开票步骤  下一步
      next(){
        //debugger
        if(this.multipleSelection){
          this.totalPrice=0;
            this.isNexButton = false
            this.isYButton =true
            this.isPevButton =true
            this.nexShow = true
            this.priceShow =true
            this.isListShow = false;
            //if (this.active++ > 2) this.active = 0;
            this.active = 1;
             this.companyName="";
            this.applyNo="";
            //isNexButton
            this.ids =[];
            for(var i=0;i<this.multipleSelection.length;i++){
              if(this.multipleSelection.length>1){
                this.ids.push(this.multipleSelection[i].id)
                this.totalPrice += Number(this.multipleSelection[i].totalAmount)
              }else{
                this.ids.push(this.multipleSelection[i].id)
                this.totalPrice = this.multipleSelection[i].totalAmount
              }

            }
            this.totalPrice =http.changeUnitPrice( this.totalPrice);
        }else{
            this.$message({
              showClose: true,
              message: '请您至少选择1件商品！',

            });
        }
        this.multipleSelection ="";
      },
      //开票步骤  上一步
      prev(){
        this.isNexButton = true
        this.isPevButton =false
        this.isYButton =false
         this.priceShow = false
        this.nexShow = false
        this.isListShow = true
        this.isPrivate = false;
        this.active = 0;
        if(this.saveSelectData.length){
          this.multipleSelection = this.saveSelectData
        }
        //this.$refs.multipleTable.toggleRowSelection(this.gridDatas[i], true);
      },
      invoiceNoChange(){
           let regx = /^[a-zA-Z0-9]{12,20}$/;
            if(!regx.test(this.applyNo)) {
              this.isRegx = true;
              return false;
            }else{
              this.isRegx = false;
              this.tipError = false;
              return true;
            }
            //this.tipError = false;

      },
      //开票步骤  确定开票
      submit(){
        if(!this.isPrivate && this.invoiceNoChange() ){
             this.tipError = false;
            let regx = /^[a-zA-Z0-9]{12,20}$/;
            if(!regx.test(this.applyNo.trim())) {
              //this.tipError = true;
              return this.isRegx = true;
            }else{
              debugger;
              this.isRegx = false;
              let contractInfoId = localStorage.getItem("contractInfoId");
             let datas = {
              'relatedOrderIds':this.ids.join(),
              "billingType":this.radio,
              "billingTitle":this.companyName,
              "taxpayerNo":this.applyNo,
              "billingAmount":this.totalPrice,
               "contractId" : contractInfoId
            }
            axios.defaults.headers ={
              "content-type": "application/json",
              "token": localStorage.getItem("Authorization")
            }
            axios.post('/mallApi/mall/invoiceRecord/add',datas).then((res) => {
                res = res.data;
                if(res.success){
                    this.sucShow=true
                    this.isListShow = false
                    this.nexShow = false
                    this.priceShow = false
                    this.isShowButton = true
                    this.isButton=false
                    this.isNexButton=false
                    this.isYButton=false
                    this.isPevButton =false
                    this.isPrivate = false
                    this.active = 2;
                }else{
                  if(res.code == 401|| res.code == 400) {
                     http.setLocalStorge();
                    this.$router.push({path: '/login'});
                  }else{
                    //this.fullscreenLoading=false;
                    this.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
                  }
                }
            })
            }
        }else{
           let datas = {
              'relatedOrderIds':this.ids.join(),
              "billingType":this.radio,
              "billingTitle":this.companyName,
              "taxpayerNo":this.applyNo,
              "billingAmount":this.totalPrice
            }
            axios.defaults.headers ={
              "content-type": "application/json",
              "token": localStorage.getItem("Authorization")
            }
            axios.post('/mallApi/mall/invoiceRecord/add',datas).then((res) => {
                res = res.data;
                if(res.success){
                    this.sucShow=true
                    this.isListShow = false
                    this.nexShow = false
                    this.priceShow = false
                    this.isShowButton = true
                    this.isButton=false
                    this.isNexButton=false
                    this.isYButton=false
                    this.isPevButton =false
                    this.isPrivate = false
                    this.active = 2;
                }else{
                  if(res.code == 401|| res.code == 400) {
                     http.setLocalStorge();
                    this.$router.push({path: '/login'});
                  }else{
                    //this.fullscreenLoading=false;
                    this.$message({
                      showClose: true,
                      message: '操作失败！',
                      type: 'error'
                    });
                  }
                }
            })
        }
      },
      closeFn(){
          this.dialogTableVisible = false;
          this.getInvoiceData();
      },
     //打开发票详情
      serverClick(row){
        this.$router.push({ path: '/invoiceDetails', query: { 'id': row.id} });
        //window.open("#/invoiceDetails?id="+row.id);
      },
      orderClick(row){
         window.open("#/orderDetails?id="+row.orderDetails[0].orderId);
      },
      inoviceTipsFun(obj){
        let cWidth = obj.target.offsetWidth;
        cWidth > 186? this.inoviceTips = false : this.inoviceTips = true;
      }
    },
    components: {
      mallHeader,
      mallFooter,
      mallBread,
      navMenu,
      http
    }
  }
</script>
<style  lang="scss">
  .el-table-filter-line {
    display: flex;padding:0px 10px 0px 0px;
    min-width: 140px;cursor: pointer;
    line-height: 30px;
    >span{
      width: 100%;
      overflow: hidden;padding-left:10px;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    svg.done{
      width: 22px;
      height: 30px;
      display: none;
      stroke-width: 2;
      stroke: #287EFF;
      margin: 0 auto;
    }
    &:hover{
      background-color: #F6F6F6;
    }
    &.active{
        color: #287EFF;
      svg.done{
        display: block;
      }
    }
  }
  .el-table-filter__bottom{
    button + button{margin-left: 10px}
  }
  .el-table th>.cell.highlight {
    color: #287EFF;
}
  .el-dialog__header {
    padding: 17px 20px 17px 20px;
    height: 50px;
  }
  .el-dialog__title {
    line-height: 20px;
    font-size: 16px;
    color:  #333333;
}
.fpClass div.el-table--scrollable-x .el-table__body-wrapper {
    overflow-x: hidden !important;
    overflow: auto;
    height: 300px;
    width: 820px;
}
button.btn-next i.el-icon.el-icon-arrow-right:hover{
  color: #287EFF;
}
button.btn-prev i.el-icon.el-icon-arrow-left:hover{
  color: #287EFF;
}
.canle-button:hover {
    background: rgba(40, 126, 255, 0.1)!important;
}
.el-button.canle-button.el-button--default:active {
    color: #287EFF!important;
    border-color: #287EFF!important;
    outline: 0px!important;
}
 .invoiceList-div  div.el-backtop {
    margin-left: 1000px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}
.invoiceList-table{
  width:920px;
   height: auto;
   background: '#E5E6E6';
   color:'#666';
   float: left;
   margin:20px 30px 20px 30px;
   min-height: 270px;
}
  .el-table th {
    padding: 8px 0 !important;
  }
   .el-table td {
    padding: 5px 0 !important;
  }

  .invoiceList-header{
      min-width: 1200px;  width: 1200px;margin: 0 auto;
  }
   .invoiceList-div div.el-table__empty-block {
    text-align: center;
    width: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    margin-bottom: 0px;
}
 .invoiceList-div .inoviceButton i {
    margin-left: -8px;
    margin-top: -3px!important;
    float: left;
}
 .inoviceButton span {
    margin-top: -3px!important;
    float: right;
    margin-right: -4px;
}
.invoiceList-div button.inoviceButton{
      border: 0px solid #DCDFE6;
}
  .invoiceList-span{
      height: 16px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      float: left;
      margin-left: 30px;
      margin-top: 20px;
  }
  .invoiceList-span-line{
    width:980px;
    border-bottom: 1px solid #EEEEEE;
    height: 1px;
    position: absolute;
    margin-top: 60px;
    margin-left: -95px
  }

  .el-radio__input.is-checked+.el-radio__label {
    color:#287EFF;
}
.el-radio__input.is-checked .el-radio__inner {
    border-color: #287EFF;
    background: #287EFF;
}

.isPrevate-css{
    position: absolute;
    margin-top: 120px;
    margin-left: 550px;
}
  .invoiceList-div{
      height: auto;
    width: 980px;
    min-width: 980px;
    margin-bottom: 60px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    overflow: auto;
    margin: 0 auto;
    float: left;
    margin-top: -360px;
    margin-left: 220px;
    min-height: 480px;
  }
  .invoiceList-div-min{
    margin-left: 520px;
    width:980px;
    height: 660px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);    margin-top: -360px;
  }
.invoice-column-button{
  font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #287EFF;cursor: pointer
}
.invoice-column-font{
  font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #287EFF;cursor: pointer
}
.inoviceButton{
      border-radius: 4px;
    font-size: 14px;
    font-family: "PingFang SC";
    font-weight: 500;
    color: rgb(255, 255, 255);
    margin-left: -65px;
    margin-top: 80px;
    width: 104px;
    height: 32px;
    background: #287EFF;
}
.inoviceButton span{
    margin-top: -14px;
    float: right;
    margin-right: -4px;
}
.inoviceButton i{
    margin-left: -8px;
    margin-top: -4px;
    float: left
}
.inoviceButton:hover{
   background: #428EFF!important;
   color: #FFFF!important;
}

.inoviceButton:active{background: #126BF0!important ;color: #FFF!important}
.inoviceButton:focus{background: #126BF0!important; color: #FFF !important;}
.invoice-column-button:hover{text-decoration: underline;border-bottom:2px; color:#287EFF solid;}
.invoice-column-font:hover{text-decoration: underline;border-bottom:2px; color:#287EFF solid;}
  .invoiceList-line{
    border-top: 1px solid rgba(51,51,51,0.15);
    width: 860px;
    position: absolute;
    margin-left: -20px;
    margin-top: -30px;
  }
  .nexShow-css{
    margin-left: 202px;
    margin-top: 70px;
  }
  .headerType-css{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 24px;
  }
  .qyunit-css{
      margin-left: 0px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      line-height: 24px;
  }
  .unqyunit-css{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 24px;
  }
  .nexShow-css-two{
    margin-left: 202px;
    margin-top: 30px;
  }
  .gsName-css{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 24px;
  }
  .gsName-value-css{
    width: 280px;
    height: 32px;
    background: #FFFFFF;
    border: 0px solid #DDDDDD;
    border-radius: 2px;
  }
  .fp-css{
    margin-left: 190px;
    margin-top: 30px;
  }
  .invoiceList-vlue-css{
    width: 280px;
    height: 32px;
    background: #FFFFFF;
    border: 0px solid #DDDDDD;
    border-radius: 2px;
  }
  .totalje-css{
    margin-left: 202px;margin-top: 30px;
  }
  .totalje-span-css{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 24px;
  }
  .totalje-num-css{
    margin-left: 10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #FF620D;
    line-height: 20px;
  }
  .prev-button{
    margin-top: 85px; width: 82px;
    height: 32px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
    line-height: 0px;
  }
  .next-button{
    margin-top: 0px;float: left;margin-left: 650px;width: 82px;line-height: 0px;
    height: 32px;
    background: #287EFF;
    border-radius: 4px;
  }
  .next-button:hover{background: #428EFF;}
   .next-button:active{
background: #126BF0;}
.sure-button:hover{background: #428EFF;}
   .sure-button:active{
background: #126BF0;}

  .sure-button{
    width: 82px;
    height: 32px;line-height: 0px;
    background: #287EFF;
    border-radius: 4px;
  }
  .canle-button{
    width: 82px;
    height: 32px;line-height: 0px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
  }
   .prev-button:hover{background: rgba(40, 126, 255, 0.1);}
  .prev-button:active{
    background: rgba(40, 126, 255, 0.1);
  }
   .prev-button:focus{
    background: rgba(40, 126, 255, 0.1);
  }
  .canle-button:active{
    background: rgba(40, 126, 255, 0.1);
  }
  .canle-button:focus{
    background: rgba(40, 126, 255, 0.1);
  }
  .canle-button:hover{background: rgba(40, 126, 255, 0.1);}
.invoiceList-defut-font{
         margin-top: -60px;
    margin-left:10px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 45px;
}
.el-table__body-wrapper {
    position: relative;

    overflow: hidden;
}


  .invoice-num-css{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 24px;
  }
  .divInit {
     margin-bottom: 80px;
    background: #FFFFFF;

  }
  .dialog-css {
    margin-bottom: -15px;
    background: #FFFFFF;

  }
  .tableDiv {
      height: auto;
      overflow: auto;
  }
 .dialogDiv  div.el-step__head.is-success {
    color: #fff;
    border-color: #287EFF;

}
.dialogDiv div.el-icon-check:before {
    content: "\e6da"!important;
}
 div.el-step__head.is-success .el-step__icon.is-text {
    background: #287EFF !important;
}
.dialogDiv .el-step__title.is-process{
  color: #287EFF;
}
.dialogDiv .el-step__head.is-process{
    color: #287EFF;
    border-color:#287EFF;
}
.el-step__title{
  height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 800;
}
.el-step__icon {

    width: 26px;
    height: 26px;
    font-size: 14px;

}
.el-step.is-horizontal .el-step__line {

    top: 13px;

}
.el-step__head.is-success .el-step__icon .is-text{
  width: 26px!important;
  height: 26px!important;
  background: #287EFF!important;
  border-radius: 50%!important;

}
.el-step__head.is-process div.el-step__icon.is-text{
  width: 26px !important;
  height: 26px !important;
  background: #287EFF !important;
  border: 2px solid #287EFF !important;
  border-radius: 50% !important;
  color: #fff;
}
.is-success div.el-step__line{
   background: #287EFF !important;
}
.dialogDiv  div.el-step__title.is-success {
    /*color: #287EFF !important;*/
    height: 14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #333333;
    line-height: 24px;
}
.step-line{
  width: 128px;
  height: 2px;
  background: #287EFF;
  border-radius: 1px;
  margin-left: 148px;
  position: absolute;
  margin-top: -22px;
}
.step-line1{
  width: 128px;
  height: 2px;
  background: #287EFF;
  border-radius: 1px;
  margin-left: 420px;
  position: absolute;
  margin-top: -22px;
}
  .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-shadow: 0 1px 3px rgba(0,0,0,.3);
    box-sizing: border-box;
    width: 50%;
    background: #FFFFFF;
    height: 600px;
    overflow: hidden;
    margin: 0 auto;
    /* max-height:600px !important; */
    /*overflow-y: auto !important;*/
}

  .el-dialog__footer {
    padding: 10px 20px 20px;
    text-align: right;

    box-sizing: border-box;
    margin-top: 30px !important;
  }
  .close-css{
    float: right;
    margin-right: 0px;
    width: 82px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    border-radius: 4px;
        height: 32px;
    line-height: 5px;
  }
  .suc-font-css{
    margin-top: 252px;
    position: absolute;
    margin-left: 355px;
    height: 15px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    line-height: 20px;
  }
  .suc-bold-font{
    margin-left: 370px;
    margin-top: 190px;
    position: absolute;
    height: 25px;
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    line-height: 20px;
  }
  .suc-img{
    position: absolute;
    margin-left: 415px;
    margin-right: 400px;
    margin-top: 100px;
    width: 60px;
    height: 60px;
  }
  table,table tr th, table tr td { border:0px solid #EEEEEE; }

</style>



// WEBPACK FOOTER //
// InvoiceList.vue?73b2a19c